module.exports = __webpack_public_path__ + "static/media/4.71cb4d47.jpg";